import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { InputAdornment, Slider } from '@material-ui/core';
import { Inputs } from '../../../../Components';
import './SliderPrimaryUnits.scss'

export const DownPaymentFilter = ({
    translationPath,
    parentTranslationPath,
    setSelected,
    selected,
    RangeSliderFilter,
}) => {
    const { t } = useTranslation(parentTranslationPath);
  const searchTimer = useRef(null);

  const handleSliderChange = (event, newValue) => {
    const [minValue, maxValue] = newValue;
    setSelected({
      id: 'DownPayment',
      value: { from: minValue, to: maxValue },
    });
    if (searchTimer.current) {
      clearTimeout(searchTimer.current);
    }
    searchTimer.current = setTimeout(() => {
      RangeSliderFilter('DownPayment', {
        from: minValue,
        to: maxValue,
      });
    }, 1000);
  };

  const handleInputChange = (value, type) => {
    if (type === 'from') {
      setSelected({
        id: 'DownPayment',
        value: { from: value },
      });
      if (searchTimer.current) {
        clearTimeout(searchTimer.current);
      }
      searchTimer.current = setTimeout(() => {
        RangeSliderFilter('DownPayment', {
          from: value,
          to: selected?.DownPayment?.to,
        });
      }, 1000);
    } else {
      setSelected({
        id: 'DownPayment',
        value: { from: selected?.DownPayment?.from, to: value },
      });
      if (searchTimer.current) {
        clearTimeout(searchTimer.current);
      }
      searchTimer.current = setTimeout(() => {
        RangeSliderFilter('DownPayment', {
          from: selected?.DownPayment?.from,
          to: value,
        });
      }, 1000);
    }
  };
  return (
    <div className='filter-slider-container'>
      <fieldset className='styled-fieldset'>
        <legend className='styled-legend'>
          {t(`${translationPath}downPayment`)}
        </legend>
        <div className='slider-wrapper'>
          <Slider
            value={[
              Number(selected?.DownPayment?.from) || 0,
              Number(selected?.DownPayment?.to) || 0,
            ]}
            onChange={handleSliderChange}
            min={0}
            max={5000}
            valueLabelDisplay='auto'
          />
        </div>
        <div className='inputs-container'>
          <Inputs
            idRef='DownPaymentFromRef'
            type='number'
            labelValue={t(`${translationPath}Min`)}
            value={selected?.DownPayment?.from || ''}
            onInputChanged={(event) => {
              const { value } = event.target;
              handleInputChange(value, 'from');
            }}
            endAdornment={<InputAdornment position='start'>AED</InputAdornment>}
            min={0}
          />
          <span className='range-separator'>-</span>
          <Inputs
            idRef='DownPaymentToRef'
            type='number'
            labelValue={t(`${translationPath}Max`)}
            value={selected?.DownPayment?.to || ''}
            onInputChanged={(event) => {
              const { value } = event.target;
              handleInputChange(value, 'to');
            }}
            endAdornment={<InputAdornment position='start'>AED</InputAdornment>}
            min={0}
          />
        </div>
      </fieldset>
    </div>
  )
}
